<template>
	<div>
		<!-- Laptop -->
		<div v-if="showScreen" class="screenSizeLap">
			<div class="login-main-container">
				<div class="h-100 d-flex align-items-center justify-content-center">
					<div class="login-main-sub-container position-relative w95h95vh">
						<b-row class="m-0 w-100">
							<b-col class="p-0">
								<div
									class="w-100 d-flex justify-content-center align-items-baseline"
								>
									<img
										src="https://d33yrtc8qntbdn.cloudfront.net/Hire3xAssests/Logo/SVG/Hire3x_Website_Header.svg"
										style="display: block; visibility: visible; opacity: 1; height: 40px"
										alt=""
									/>
								</div>
							</b-col>
						</b-row>
						<b-row class="m-0 w-100" style="height: 95%">
							<b-col class="p-0">
								<div
									class="d-flex align-items-center flex-column mt-3 text-center completeddetails-container"
								>
									<div
										class="h-100 w-50 d-flex justify-content-center flex-column"
									>
										<h1 class="login-rightcont-headtxt pt-3">Alert</h1>
										<div class="mt-3 h-100">
											<div class="d-flex align-items-center mt-5 flex-column">
												<div
													style="width: fit-content"
													class="mt-3 completed-card-container px-5 py-4 position-relative"
												>
													<div
														class="cmpltedsucc-icon"
														style="left: 45%; top: -40px"
													>
														<img
															src="../../assets/newui-img/alertimage.svg"
															alt=""
														/>
													</div>
													<div
														class="d-flex align-items-center flex-column justify-content-center mt-5"
													>
														<div class="comp-maintxt">
															{{ apiResponse }}
														</div>
													</div>
													<div
														class="mt-5 d-flex align-items-center justify-content-center bluebtns"
													>
														<b-button variant="primary" @click="goToHire3x"
															>Go To Hire3x</b-button
														>
													</div>
												</div>
											</div>
										</div>
									</div>
								</div>
							</b-col>
						</b-row>
					</div>
				</div>
			</div>
		</div>

		<!-- Mobile -->
		<div v-if="showScreen" class="screenSizeMobile">
			<div class="mobileScreen-main-container">
				<div
					class="mobileScreen-main-innerContainer d-flex align-items-center justify-content-center flex-column"
				>
					<div class="mobilescreen-completed">Alert</div>
					<div class="mt-4">
						<img
							src="../../assets/mobile-newUI-imgs/new-warning-icon.svg"
							alt=""
						/>
					</div>
					<div
						class="mt-4 text-center mobileScreen-TD-otherInfo-subhead"
						style="width: 93%"
					>
						{{ apiResponse }}
					</div>
					<div
						class="mt-5 d-flex align-items-center justify-content-center bluebtns"
					>
						<b-button variant="primary" @click="goToHire3x"
							>Go To Hire3x</b-button
						>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
import eventBus from "../../utils/eventBus.js";
export default {
	name: "LoginModals",
	created() {
		eventBus.$on("show-modal", this.displayModal);
	},
	beforeDestroy() {
		eventBus.$off("show-modal", this.displayModal);
	},
	data() {
		return {
			apiResponse: null,
			showScreen: false,
		};
	},
	methods: {
		displayModal(response) {
			this.apiResponse = response;
			this.showScreen = true;
		},
		goToHire3x() {
			localStorage.clear();
			location.replace("https://hire3x.com");
		},
	},
};
</script>

<style scoped>
@media only screen and (max-width: 821px) {
	.screenSizeLap {
		display: none;
	}
}
@media only screen and (min-width: 821px) {
	.screenSizeMobile {
		display: none;
	}
}

/* ── Laptop layout — mirrors CompletedTest.vue exactly ── */
.login-main-container {
	height: 100vh;
}
.login-main-sub-container {
	width: 100%;
	height: 100vh;
	display: flex;
	flex-direction: column;
	padding: 20px 40px 0;
}
.completeddetails-container {
	height: calc(100vh - 123px);
	overflow: auto;
	border-radius: 14px;
	background: url("../../assets/newui-img/checkkk.png");
	background-repeat: no-repeat;
	background-size: cover;
	padding: 30px;
	width: 100%;
}
.login-rightcont-headtxt {
	font-family: "Lato", sans-serif;
	font-weight: 700;
	font-size: 28px;
	color: #3a3c40;
}
.completed-card-container {
	background: #ffffff;
	border-radius: 16px;
	box-shadow: 0px 4px 32px rgba(0, 0, 0, 0.1);
	min-width: 420px;
}
.cmpltedsucc-icon {
	position: absolute;
}
.comp-maintxt {
	font-family: "Lato", sans-serif;
	font-weight: 500;
	font-size: 18px;
	text-align: center;
	color: #3a3c40;
}

/* ── Mobile layout ── */
.mobileScreen-main-container {
	height: 100vh;
}
.mobileScreen-main-innerContainer {
	height: 100%;
	padding: 24px;
}
.mobilescreen-completed {
	font-family: "Lato", sans-serif;
	font-weight: 700;
	font-size: 22px;
	color: #3a3c40;
}
.w95h95vh {
	width: 95%;
	height: 95vh;
}
</style>
